import { cn } from "@reactive-resume/utils";

import { NotificationCenter } from "@/client/services/notification";

type NotificationBellProps = {
  classNameTrigger?: string;
};

/**
 * Cloche de notifications de l'espace utilisateur.
 *
 * Délègue au NotificationCenter (popover, badge de non-lectures,
 * temps réel, opt-in push) et calibre le déclencheur pour le design
 * user-space : tuile blanche bordée, survol indigo, focus accessible.
 */
export const NotificationBell = ({ classNameTrigger }: NotificationBellProps) => (
  <NotificationCenter
    classNameTrigger={cn(
      "size-11 rounded-xl",
      "border border-slate-200 bg-white text-indigo-950",
      "shadow-sm transition-all duration-200",
      "hover:border-indigo-200 hover:bg-indigo-50",
      "hover:shadow-md",
      "focus-visible:outline-none focus-visible:ring-2",
      "focus-visible:ring-indigo-500",
      classNameTrigger,
    )}
  />
);
